module.exports = __webpack_public_path__ + "static/rainbowsafarihamper-f1f0dd36228bd487dee7539b56f351a7.jpeg";